import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

export abstract class StructureVisibilityBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.HIDDEN_NODE;
  }
}
